"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as t } from "../../../utils/styles.mjs";
import { Text as n } from "../Text/Text.mjs";
import { ChevronDown as r, ChevronUp as i } from "../Icon/icons.gen.mjs";
import { forwardRef as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as c from "@radix-ui/react-select";
//#region src/components/atoms/Select/Select.tsx
var l = ({ ...e }) => /* @__PURE__ */ o(c.Root, {
	"data-slot": "select",
	...e
}), u = ({ ...e }) => /* @__PURE__ */ o(c.Group, {
	"data-slot": "select-group",
	...e
}), d = ({ ...e }) => /* @__PURE__ */ o(c.Value, {
	"data-slot": "select-value",
	...e
}), f = a(({ className: n, iconPrefix: r, iconSuffix: i, children: a, ...l }, u) => /* @__PURE__ */ s(c.Trigger, {
	"data-slot": "select-trigger",
	className: e("group flex w-fit items-center justify-between gap-2 rounded-sm bg-transparent whitespace-nowrap disabled:cursor-not-allowed *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0", t(), n),
	ref: u,
	...l,
	children: [
		r && /* @__PURE__ */ o("div", { children: r }),
		a,
		i && /* @__PURE__ */ o("div", { children: i })
	]
}));
f.displayName = "SelectTrigger";
var p = ({ className: t, ...n }) => /* @__PURE__ */ o(r, {
	className: e("size-3 fill-black transition-transform duration-200 group-data-[state=open]:rotate-180 dark:fill-white group-disabled:dark:fill-neutral-dark-600", t),
	...n
}), m = ({ className: t, children: n, container: r, position: i = "popper", align: a = "start", ...s }) => /* @__PURE__ */ o(c.Portal, {
	container: r,
	children: /* @__PURE__ */ o(c.Content, {
		"data-slot": "select-content",
		className: e("relative z-50 max-h-(--radix-select-content-available-height) origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-xl data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", i === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", t),
		position: i,
		align: a,
		...s,
		children: /* @__PURE__ */ o(c.Viewport, {
			className: e(i === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
			children: n
		})
	})
}), h = ({ className: t, children: r, fontWeight: i, fontSize: a, fontFamily: s, ...l }) => /* @__PURE__ */ o(c.Label, {
	"data-slot": "select-label",
	className: e("text-neutral-dark-600 dark:text-neutral-dark-1000 ", t),
	asChild: !0,
	...l,
	children: /* @__PURE__ */ o(n, {
		asChild: !0,
		fontWeight: i,
		fontSize: a,
		fontFamily: s,
		children: r
	})
}), g = ({ className: e, children: t, fontWeight: r, fontSize: i, fontFamily: a, ...s }) => /* @__PURE__ */ o(c.ItemText, {
	asChild: !0,
	className: e,
	...s,
	children: /* @__PURE__ */ o(n, {
		asChild: !0,
		fontWeight: r,
		fontSize: i,
		fontFamily: a,
		children: t
	})
}), _ = ({ className: t, children: n, ...r }) => /* @__PURE__ */ o(c.Item, {
	"data-slot": "select-item",
	className: e("relative flex w-full hover:cursor-pointer items-center gap-2 py-2 px-4 outline-hidden select-none data-disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", t),
	...r,
	children: n
}), v = ({ className: t, ...n }) => /* @__PURE__ */ o(c.Separator, {
	"data-slot": "select-separator",
	className: e("pointer-events-none -mx-1 my-1 h-px bg-border", t),
	...n
}), y = ({ className: t, ...n }) => /* @__PURE__ */ o(c.ScrollUpButton, {
	"data-slot": "select-scroll-up-button",
	className: e("flex cursor-default items-center justify-center py-1", t),
	asChild: !0,
	...n,
	children: /* @__PURE__ */ o(i, { className: "size-4" })
}), b = ({ className: t, ...n }) => /* @__PURE__ */ o(c.ScrollDownButton, {
	"data-slot": "select-scroll-down-button",
	className: e("flex cursor-default items-center justify-center py-1", t),
	asChild: !0,
	...n,
	children: /* @__PURE__ */ o(r, { className: "size-3" })
});
//#endregion
export { m as SelectContent, u as SelectGroup, p as SelectIcon, _ as SelectItem, g as SelectItemText, h as SelectLabel, l as SelectRoot, b as SelectScrollDownButton, y as SelectScrollUpButton, v as SelectSeparator, f as SelectTrigger, d as SelectValue };
